const ja = {
    ChatLayout: {
        nav_chat: "チャット",
        resource: "リソース管理",
        upload: "リソース登録",
        template_management: "テンプレート管理",
        history: "履歴",
        setting: "設定",
        connection: "システム連携",
        delete: "削除",
        clear_messages: "クリア",
        back: "戻る",
    },
    NavBar: {
        chats: "チャット一覧",
        admin: "設定",
        settings: "プロフィール",
        logout: "ログアウト",
        saleslists: "リスト一覧",
        salestemplate: "テンプレート",
        usage: "利用状況",
        enduser_chat: "エンドユーザー",
    },
    EnduserChat: {
        page_title: "エンドユーザー向けチャット",
        tab_settings: "設定",
        tab_talks: "会話ログ",
        tab_usage: "使用量",
        back: "戻る",
        // settings
        display_settings: "表示設定",
        is_enabled: "AI チャットを表示",
        source_chat: "既定の参照ナレッジ（チャット）",
        source_chat_hint: "メニューで個別指定が無い場合に使うナレッジベース（フォールバック）",
        source_chat_unset: "（未選択）",
        menu_label: "メニュー名（ボタン表示）",
        menu_source_chat: "参照チャット",
        menu_source_chat_default: "（既定を使用）",
        menu_source_chat_hint: "各メニューで参照するナレッジ（チャット）を個別に選択できます。未選択のメニューは上の「既定の参照ナレッジ」を使用します。",
        enabled_on: "公開中",
        enabled_off: "非公開",
        enabled_hint: "OFF にすると休止モード（フォーム導線のみ）になります",
        auto_disable: "ハード上限超過で自動 OFF にする",
        memory_flag: "会話記憶",
        memory_flag_hint: "ON にすると、同一トーク内の直前のやり取りを踏まえて AI が回答します",
        greeting_message: "挨拶メッセージ",
        ui_texts: "固定テキスト（任意編集）",
        ui_texts_hint: "チャット画面に固定表示される文言を上書きできます。未入力の項目は既定の文言が使われます。",
        txt_header_title: "タイトルバー",
        txt_menu_prompt: "メニュー選択の案内文",
        txt_composer_prompt: "入力欄の案内文",
        txt_loading: "回答生成中の表示文言",
        txt_loading_hint: "回答待ちの間、点滅ドット（・・・）と一緒に表示されます。未入力の場合はドットのみ表示されます。",
        txt_no_answer: "該当情報なし時の文言",
        txt_no_answer_hint: "AIが回答を見つけられなかった時の文言です。AI生成のため、多少言い換えられる場合があります。",
        txt_feedback_prompt: "解決確認の文言",
        txt_feedback_yes: "「はい」選択時の文言",
        txt_feedback_no: "「いいえ」選択時の文言",
        txt_escalate_message: "フォーム誘導の文言（「いいえ」選択時など）",
        txt_escalate_message_hint: "「いいえ」を選んだ時やフォーム導線クリック時に表示されます。",
        txt_escalate_link: "問い合わせフォームのリンク文言",
        txt_escalate_link_hint: "会話下部の常設導線・該当なし時・休止画面のフォームリンクに共通で使われます。",
        txt_footer_escalate_prefix: "常設フォーム導線の前置き文言（任意）",
        txt_footer_escalate_prefix_hint: "会話下部に常設表示されるフォーム導線のリンク前の文言です。空欄ならリンク文言のみ表示します。",
        txt_no_answer_prompt: "フォーム導線の前置き文言（該当なし時）",
        dormant_title: "休止モードの表示（AIチャット非表示時）",
        dormant_hint: "「AI チャットを表示」がOFFの時にウィジェットに表示される内容です。未入力は既定文言を使用します。",
        dormant_message: "案内文（上部）",
        txt_disabled_message: "制限到達・利用停止時の応答文",
        txt_disabled_message_hint: "ポイント上限到達や停止中に、会話内で送信された際に返す文言です。未入力は既定文言を使用します。",
        txt_limit_reached_message: "上限到達時の回答文（最初の1回）",
        txt_limit_reached_message_hint: "会話中にハード上限へ達した際、その回の回答として返す文言です（システムエラー表示を回避）。この後は自動OFFになり「制限到達・利用停止時の応答文」に切り替わります。未入力は既定文言を使用します。",
        dormant_links: "リンクボタン（FAQ・規約・ガイド等）",
        dormant_link_label: "ボタン名",
        dormant_add_link: "リンクを追加",
        dormant_footer: "案内文（下部・任意）",
        character_image: "キャラクター画像",
        character_image_hint: "推奨: 正方形・320×320px 以上の PNG（円形に切り抜かれて表示されます。高解像度端末でも綺麗に表示するため、表示サイズの2倍以上を推奨）",
        promo_char_image: "集客用キャラクター画像（吹き出し横の立ち絵）",
        promo_char_image_hint: "起動ボタン横に立ち絵＋吹き出し「お困りですか？」を表示します。この画像を設定した時のみ表示され、未設定なら表示しません（チャット内アバターとは別画像）。推奨: 背景透過の縦長PNG。利用者が畳むと起動ボタンのみになります。",
        character_size: "起動ボタンのアイコンサイズ",
        character_size_pc: "PC",
        character_size_mobile: "スマホ",
        character_size_hint: "チャット起動ボタンのアイコンサイズ（20〜160px）。未入力の場合は標準の 28px で表示されます。",
        character_chat_size: "チャット内アイコンサイズ",
        character_chat_size_hint: "各メッセージ横に表示されるアイコンのサイズ（20〜120px）。未入力の場合は標準の 30px で表示されます。",
        contact_form_url: "問い合わせフォーム URL",
        min_message_length: "最小送信文字数",
        model: "使用モデル",
        // widget embed
        widget_embed: "ウィジェット設置",
        widget_embed_show: "設置情報を表示",
        widget_embed_hide: "設置情報を隠す",
        widget_embed_secure_hint: "公開 API キー・埋め込みスニペットなどの設置情報は、セキュリティのため通常は非表示です。必要な時のみ「設置情報を表示」を押してください。",
        api_key: "公開 API キー",
        copy: "コピー",
        rotate_key: "再発行",
        rotate_confirm: "API キーを再発行しますか？既存のキーは即座に無効化されます。",
        rotate_keyword: "再発行",
        rotate_modal_title: "公開 API キーの再発行",
        rotate_modal_warn_head: "この操作は取り消せません。実行すると：",
        rotate_modal_warn_1: "現在の公開 API キーが即座に無効になります。",
        rotate_modal_warn_2: "設置済みのすべてのウィジェットが停止します（回答できなくなります）。",
        rotate_modal_warn_3: "全設置箇所の埋め込みタグを新しいキーに差し替える必要があります。",
        rotate_modal_input_label: "実行するには次の語句を入力してください：",
        rotate_modal_cancel: "キャンセル",
        rotate_modal_execute: "再発行を実行",
        rotate_final_confirm: "本当に再発行しますか？既存キーは即座に無効になり、元に戻せません。",
        allowed_origins: "許可 Origin",
        add_origin: "Origin を追加（例: https://www.example.com）",
        embed_snippet: "埋め込みスニペット",
        // alert
        budget_alert: "予算アラート（Slack 通知）",
        warning_threshold: "警告閾値（pt）",
        hard_limit: "ハード上限（pt）",
        slack_webhook: "Slack Webhook URL",
        slack_mentions: "メンション先（Slack ユーザーID・カンマ区切り）",
        test_slack: "テスト送信",
        // menu
        menu_definitions: "クイックメニュー定義",
        add_menu: "メニューを追加",
        // common
        save: "保存",
        discard: "変更を破棄",
        saved: "保存しました",
        save_failed: "保存に失敗しました",
        loading: "読み込み中...",
        // talks list / detail / usage
        filter_from: "期間（開始）",
        filter_to: "期間（終了）",
        filter_menu: "メニュー",
        filter_status: "状態",
        filter_talk_id: "トークID",
        filter_talk_id_ph: "トークID（完全 / 一部）",
        filter_keyword: "キーワード",
        filter_keyword_ph: "顧客メッセージを部分一致で検索",
        filter_all: "すべて",
        search: "検索",
        unresolved: "未解決",
        resolved: "解決",
        status_none: "未回答",
        no_data: "データがありません",
        col_datetime: "送信日時",
        col_talk_id: "トークID",
        detail_internal_id: "内部ID",
        col_menu: "メニュー",
        col_user: "ユーザー",
        col_first_message: "最初のメッセージ",
        col_count: "件数",
        col_status: "状態",
        col_points: "消費pt",
        usage_month_label: "対象月",
        usage_points: "当月消費ポイント（社内+社外 合算）",
        usage_hard_limit: "ハード上限（社内+社外 合算）",
        usage_warning_hint: "警告閾値に対する消費量（社内・社外の合算）",
        usage_hard_hint: "超過で AI チャット自動 OFF（合算値で判定）",
        usage_unresolved_rate: "未解決率（当月）",
        usage_resolved_rate: "解決率（当月）",
        usage_messages: "メッセージ数（当月）",
    },
    EditGroupView: {
        h1: "グループ編集：",
        group_name: "グループ名：",
        created_at: "作成日時：",
        modified_at: "最終更新日時：",
        user_group_h4: "グループのユーザー登録",
        username: "ユーザーID",
        fullname: "氏名",
        roles: "権限",
        user_group_h4_2: "グループのチャット登録",
        chat_title: "チャットボット名",
        submit: "更新",
        handleBack: "戻る",
        edit_group_err: "グループの編集は失敗しました！",
    },
    EditUserView: {
        h1: "ユーザー編集：",
        username: "ユーザーID：",
        mail_address: "メールアドレス：",
        full_name: "氏名：",
        password: "パスワード：",
        show: "表示",
        not_show: "非表示",
        roles: "権限：",
        groups: "グループ：",
        created_at: "アカウント登録日時：",
        modified_at: "最終更新日時：",
        submit: "更新",
        handleBack: "戻る",
        change_password: "パスワード初期化",
        password_format_err: "パスワードは最低8文字、大文字、小文字、数字、特殊文字を含む必要があります。",
        role_error: "権限を選択してください。",
        group_error: "ユーザー所属のグループを選択してください。",
        username_error: "ユーザーIDを入力してください。",
    },
    NewGroupView: {
        h1: "グループ追加",
        group_name: "グループ名：",
        user_group_h4: "グループのユーザー登録",   
        username: "ユーザーID",
        fullname: "氏名",
        roles: "権限",
        user_group_h4_2: "グループのチャット登録",
        chat_title: "チャットボット名",
        submit: "保存",
        handleBack: "戻る",
        new_group_err: "グループ登録は失敗しました！\nすでに登録したグループかどうかを確認してください。",
        registered_group: "※すでに登録されたグループ名です。",
    },
    NewUserView: {
        h1: "ユーザー追加",
        username: "ユーザーID：",
        full_name: "氏名：",
        password: "パスワード：",
        show: "表示",
        not_show: "非表示",
        roles: "権限：",
        groups: "グループ：",
        submit: "新規登録",
        handleBack: "戻る",
        password_format_err: "パスワードは最低8文字、大文字、小文字、数字、特殊文字を含む必要があります。",
        role_error: "権限を選択してください。",
        group_error: "ユーザー所属のグループを選択してください。",
        username_error: "ユーザーIDを入力してください。",
    },
    UserListView: {
        user_h4: "ユーザー一覧",
        add_User: "ユーザー追加",
        username: "ユーザーID",
        fullname: "氏名",
        roles: "権限",
        groups: "グループ",
        modified_at: "最終ログイン",
        created_at: "登録日時",
        operation: "操作",
        edit: "編集",
        delete: "削除",
        group_h4: "チャットアクセス権限グループ一覧",
        add_group: "グループ追加",
        group_name: "グループ名",
        update_date_time: "更新日時",
        ip_h4: "アクセス可能のIP一覧",
        ip_list: "IP",
        add_ip: "IP追加",
        modal_title: "警告",
        warning_msg_1: "グループを削除した場合",
        warning_msg_2: "グループに入ったユーザーとチャットはこのグループから解放されます。",
        warning_msg_3: "該当グループしか関連していないチャットは管理者以外のユーザーが閲覧、または編集できません。",
        warning_msg_4: "よろしいでしょうか？",
        user_warning_msg_1: "本当にユーザーを削除しますか？",
        cancel: "キャンセル",
        del_err: "グループの削除は失敗しました。\n存在していないグループです。\n画面をリフレッシュしてまた、操作してください。",
        ip_del_err: "IPの削除は失敗しました。",
        ip_edit_err: "IPアドレスではありません。IPアドレスを入力してください。",
        ip_edit_err2: "このIPアドレスは既に存在しています。",
        ip_save_err: "IPの保存は失敗しました。",
        save: "保存",
    },
    AdminErrorView: {
        h1: "アクセス権限がありません",
        error_message: "システム管理者にアクセス権限をリクエストするか、アクセス権のあるアカウントに切り替えてください。",
        back_button: "戻る",
    },
    ChatResourceUploadView: {
        h1: "リソース登録",
        resource_type: "リソースタイプ",
        file: "ファイル",
        text: "テキスト",
        text_content: "テキスト内容",
        text_placeholder: "登録するテキストを入力してください",
        resource_name: "リソース名",
        uploadText: "登録",
        no_text: "テキストが入力されていません。",
        text_registered: "テキストを登録しました。",
        processing: "登録中...",
        choose_file: "ファイルを選択",
        file_name: "ファイル名",
        tags: "タグ",
        tags_format: "タグ1,タグ2,タグ3",
        upload: "アップロード",
        page_title: "ページタイトル",
        page_name: "ページ名",
        uploadWebResource: "登録",
        no_files_selected: "ファイルが選択されていません。",
        update_ok_msg: "アップロード成功。",
        update_err_msg: "アップロードに失敗しました。",
        response_ok_msg: "登録成功。",
        response_err_msg: "登録に失敗しました。",
    },
    ChatTemplateManagementView: {
        h4: "テンプレート管理",
        search_keyword: "テンプレート名キーワード：",
        new_template: "新規作成",
        search: "絞り込み",
        template_name: "テンプレート名",
        created_at: "作成日時",
        modified_at: "更新日時",
        operation: "操作",
        delete: "削除",
        template_url: "スプレッドシートURL",
        update_template_title: "テンプレートアップロード",
        update: "更新",
        cancel: "キャンセル",
        warning_msg_1: "選択したテンプレートを削除します。",
        warning_msg_2: "よろしいでしょうか？",
    },
    ChatResourceView: {
        h4: "登録済みリソース一覧",
        keyword: "キーワード",
        tags: "タグ",
        total_number_of_characters: "文字数合計：",
        resource_count: "リソース数：",
        filter: "絞り込み",
        resource_name: "リソース名",
        file_type: "ファイル形式",
        created_at: "登録日時",
        status: "ステータス",
        operation: "操作",
        edit: "編集",
        delete: "削除",
        status_zero: "処理待ち",
        status_one: "読込中",
        status_two: "完了",
        status_three: "エラー",
        resource: "リソース：",
        delete_confirm: "を削除しますか？",
        yes: "はい",
        cancel: "キャンセル"
    },
    ChatScreenView: {
        input_msg: "メッセージを入力してください",
        error_messages: "申し訳ありませんが、リクエスト中に問題が発生しました。しばらくしてからもう一度試してください。",
        close: "閉じる",
        template_message: "質問テンプレート",
        link: "外部リンク",
        no_source_link: "原本リンクなし",
        reference_source: "参考資料",
        new_talk: "+ 会話作成",
        his_talk: "会話履歴",
        memory_flag: "会話記憶",
        template_search: "テンプレート検索",
        copy: "回答コピー",
    },
    ChatSettingView: {
        h4: "チャットボット設定",
        chat_namespace: "チャットID：",
        chat_title: "チャットボット名：",
        system_prompt: "システムプロンプト：",
        temperature: "応答の柔軟性：",
        model: "モデル",
        template_message: "選択肢メッセージ：",
        add: "追加",
        del: "削除",
        title: "タイトル",
        msg: "メッセージ内容",
        must: "入力必須",
        group: "閲覧可能のグループ",
        memory: "会話記憶",
        update: "更新",
        handle_return: "戻る",
        alert_max_10: "テンプレート登録は最大10個までです。",
        alert_not_edit: "選択肢メッセージに未記入の質問があります。\n質問を削除しまたは記入してください。",
        chat_setting_err_msg: "チャットの設定は失敗しました。",
        chat_setting_ok_msg: "チャットの設定は完了しました。",
        resource_type: "リソース種別：",
        template_name: "テンプレート名：",
        resource_rag: "リソース(RAG)",
        template: "テンプレート",
        template_err: "先にテンプレートを登録してください。",
    },
    NewChatView: {
        h3: "チャットボット作成",
        groups: "閲覧可能のグループ",
        chat_title: "チャットボット名：",
        system_prompt: "システムプロンプト：",
        temperature: "応答の柔軟性：",
        group_err: "閲覧できるグループを選択してください。",
        memory: "会話記憶",
        handleCreate: "新規登録",
        handleReturn: "戻る",
    },
    EditPasswordView: {
        h1: "パスワード変更",
        old_password: "元のパスワード：",
        incorrect_password: "パスワードが正しくありません！",
        new_password: "新しいパスワード：",
        new_password_confirmation: "新しいパスワード（確認）：",
        passwords_do_not_match: "パスワードが一致しません！",
        password_format_err: "パスワードは最低8文字、大文字、小文字、数字、特殊文字を含む必要があります。",
        submit: "変更",
        handleBack: "戻る",
    },
    SettingsView: {
        h4: "プロフィール",
        username: "ユーザーID：",
        full_name: "氏名：",
        mail_address: "メールアドレス：",
        not_mail_address: "入力したデータはメールアドレスではありません！",
        otp_on: "ログイン時にメールで２段階認証を行います。",
        otp_warning: "**注意：２段階認証を行う場合はメールアドレスが必須となります。",
        modal_title: "メールアドレス検証",
        modal_body: "認証コード：",
        otp_msg: "メールに送信した２段階認証コードを入力してください。",
        invalid_otp_code_1: "認証コードが正しくありません！",
        invalid_otp_code_2: "２段階認証はメールアドレスの入力が必須です。",
        setting_ok: "設定は完了しました。",
        send_btn: "送信",
        close_btn: "キャンセル",
        change_password: "パスワード変更",
        update: "更新",
        handle_return: "戻る",
        user_plan: "ご契約プラン照会",
    },
    UserPlanView: {
        plan_detail: "月次利用状況",
        model: "モデル",
        messages_total: "メッセージ合計",
        points_per_message: "1回あたりのポイント",
        points_unit: "ポイント",
        total_points: "ポイント合計",
        count: "合計",
        resource_detail: "リソース利用量",
        element: "項目",
        resource_characters_count: "リソース文字数",
        user_count: "ユーザー数",
        chat_count: "チャットボット数",
        usage_amount: "利用量",
        limit: "制限",
        cost: "月次費用合計",
        amount: "金額",
        total_amount: "合計金額",
        csv: "CSVエクスポート",
        csv_by_user: "ユーザー別CSVエクスポート",
        handle_return: "戻る",
        point_fee_table: "ポイント料金表",
        points_used: "ポイント使用量",
        fee: "料金"
    },
    ChatListView: {
        h4: "チャットボット一覧",
        serach_keyword: "キーワード：",
        chat_count: "チャットボット数：",
        handle_create: "新規作成",
        handle_filter: "絞り込み",
        chat_title: "チャットボット名",
        author: "作成日時",
        operation: "操作",
        delete: "削除",
        modal_title: "警告",
        warning_msg_1: "チャットを削除します。",
        warning_msg_2: "よろしいでしょうか？",
        cancel: "キャンセル",
    },
    ChatView: {
        enter_message: "メッセージを入力してください",
        file_name: "ファイル名",
        tags: "タグ",
        source: "【参照元】：",
    },
    ChatEditResourceView: {
        h4: "リソース編集",
        resource_name: "リソース名：",
        file_type: "ファイル形式：",
        tags: "タグ",
        description: "備考：",
        status: "ステータス：",
        created_at: "登録日時：",
        modified_at: "更新日時：",
        resource_text: "テキスト：",
        submit: "更新",
        backToResources: "戻る",
        error_messages: "エラーが発生しました",
        close: "閉じる",
    },
    ChatConnectionView: {
        h4: "外部システム連携",
        messenger: "Messenger",
        messenger_service_name: "接続先サービス：",
        messenger_active_status: "有効状態：",
        messenger_callback_url: "コールバックURL：",
        messenger_verify_token: "認証トークン：",
        messenger_facebook_page_id: "FacebookページID：",
        messenger_access_token: "アクセストークン：",
        submit: "更新",
        hide_token: "非表示",
        show_token: "表示",
        error_messages: "エラーが発生しました",
        error_messages_fbduplicate: "facebookページIDが重複しているため更新できませんでした",
    },
    LoginView: {
        username: "ユーザー名：",
        invalid_username_or_password: "ユーザー名またはパスワードが正しくありません！",
        modal_title: "２段階認証",
        modal_body: "認証コード：",
        otp_msg: "メールに送信した２段階認証コードを入力してください。",
        invalid_otp_code_1: "認証コードが正しくありません！",
        invalid_otp_code_2: "認証回数が越えています。最初からやり直してください。",
        send_btn: "送信",
        close_btn: "キャンセル",
        password: "パスワード：",
        submit: "ログイン",
        ip_modal_title: "IP制限に関する情報",
        ip_err_1: "このPCのIPアドレスはログインできません。",
        ip_err_2: "IP権限管理者に連絡してください。",
    },
    RegisterView: {
        h4: "登録済みリソース一覧",
        search_keyword: "キーワード",
        tags: "タグ",
        total_number_of_characters: "文字数合計：",
        resource_count: "リソース数：",
        filter: "絞り込み",
        resource_name: "リソース名",
        file_type: "ファイル形式",
        created_at: "登録日時",
        status: "ステータス",
        operation: "操作",
        edit: "編集",
        delete: "削除",
    },
    UploadFileView: {
        upload_title: "リソース登録",
        resource_type: "リソースタイプ",
        file: "ファイル",
        file_upload: "ファイルを選択",
        file_name: "ファイル名",
        tags: "タグ",
        tags_format: "タグ1,タグ2,タグ3",
        uploadFile: "アップロード",
        document_title: "ページタイトル",
        uploadWebResource: "登録",
    },
    TagsInput: {
        admin_del_msg: "管理者が全てのチャットが管理できるために管理者ユーザー権限は削除できません。",
    },

    UploadServiceView: {
        // upload_title    : "1. リソース登録",
        resource_type: "リソースタイプ",
        file: "ファイル",
        file_upload: "ファイルを選択",
        // file_name       : "5. ファイル名",
        // tags            : "6. タグ",
        // tags_format     : "7. タグ1,タグ2,タグ3",
        uploadFile: "アップロード",
        // document_title  : "9. ページタイトル",
        uploadWebResource: "登録",
    },

    SalesListsView: {
        h4: "リスト一覧",
        search_keyword: "キーワード：",
        list_count: "リスト数：",
        handle_create: "新規作成",
        list_title: "リスト名",
        author: "作成日時",
        edit: "編集",
        delete: "削除",

        delete_confirm: "選択したリストを削除しますか？",
        OK: "削除する",
        cancel: "キャンセル"
    },

    SalesListsDetailsLayout: {
        h1: "リストタイトル1",
        company_list: "会社一覧",
        csv_import: "CSVインポート",
        company_setting: "リスト設定"
    },

    SalesListsDetailsView: {
        h4: "会社一覧",
        search_keyword: "キーワード:",
        handle_filter: "絞り込み",
        target_flag: "生成開始",
        target: "生成対象",
        regeneration: "再生成",
        company_information: "会社情報取得",
        text_generate: "文章生成",
        text_confirm: "内容確認",
        send_mail: "メール送信",
        data_count: "データ件数：",

        select_all: "全選択/解除",
        handleCreate: "+ 会社追加",
        handle_send: "一括送信",
        refresh: "一覧更新",
        handle_refresh: "一覧更新",

        selected: "対象",
        company_name: "会社名",
        company_url: "URL",

        crawl_status: "会社情報取得",
        generate_status: "文章生成",
        check_status: "文章確認",
        send_status: "メール送信",

        process_pending: "処理待ち",
        processing: "処理中",
        finish: "完了",
        process_fail: "処理失敗",

        generate_pending: "生成待ち",
        generating: "生成中",
        generate_fail: "生成失敗",

        uncheck: "未確認",
        checked: "確認済",

        send_none: "未送信",
        send_pending: "送信待ち",
        send_processing: "送信中",
        send_finish: "送信済",
        send_fail: "送信失敗",
        send_delivered: "送信成功",
        send_open: "開封済",
        send_click: "クリック済",

        operation: "操作",
        edit: "確認・編集",
        delete: "削除",

        delete_confirm: "を削除しますか?",
        OK: "OK",
        cancel: "キャンセル",
        send_mail_modal_title: "通知",
        send_mail_modal_text: "メール送信が予約されました。 ※「文章確認」=「確認済」のレコードのみ送信されます。",

        model_title: "会社編集・確認",
        model_company_name: "会社名：",
        model_company_url: "URL:",
        model_email: "メールアドレス：",
        model_company_detail: "概要：",
        model_mail_text: "文章：",
        model_check_status: "確認済み：",
        model_update: "更新",
    },

    NewSalesListsDetailsView: {
        h3: "会社編集・確認",

        company_name: "会社名：",
        company_url: "URL:",
        email: "メールアドレス：",
        company_detail: "概要：",
        mail_text: "文章：",

        return: "戻る",
        update: "更新",
    },

    NewSalesListsView: {
        h3: "リスト新規作成 ",

        resource_type: "リソースタイプ",
        file: "ファイル",

        title_base: "基本情報",
        title_service: "商品・サービス情報",
        title_template: "テンプレート選択",

        list_name: "リスト名：",
        sender_company_name: "【送信元】 会社名：",
        sender_name: "【送信元】 担当者名：",
        sender_mail_address: "【送信元】 メールアドレス：",
        mail_title: "メールタイトル：",
        to_name: "【送信先】 宛名：",
        bcc: "【送信先】 BCC：",
        file_upload: "*添付ファイル：",
        must_pdf: "*添付ファイルはpdfのみです。",
        not_pdf: "選択したファイルはpdfではありません。",

        service_name: "営業したい商品/サービスの名称",
        service_detail_summary: "営業したい商品/サービスの概要",

        template_name: "テンプレートタイプ",

        additional_prompt: "プロンプト：",
        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "は必須項目です。入力してください。",

        return: "戻る",
        next: "次へ",
        finished: "完了",

        import: "ファイル・URLで入力",
        
    },

    EditSalesListsView: {
        h3: "リスト設定",

        resource_type: "リソースタイプ",
        file: "ファイル",

        title_base: "基本情報",
        title_service: "商品・サービス情報",
        title_template: "テンプレート選択",

        list_name: "リスト名：",
        sender_company_name: "【送信元】 会社名：",
        sender_name: "【送信元】 担当者名：",
        sender_mail_address: "【送信元】 メールアドレス：",
        mail_title: "メールタイトル：",
        to_name: "【送信先】 宛名：",
        bcc: "【送信先】 BCC：",

        service_name: "営業したい商品/サービスの名称：",
        service_detail_summary: "営業したい商品/サービスの概要：",

        template_name: "テンプレートタイプ：",

        additional_prompt: "プロンプト：",
        prompt_str: "【プロンプトとは？】<br>" +
            "本項目では、メール文面生成の際、生成AIに伝える制約事項を追記することができます。<br><br>" +
            "【具体例】<br>" +
            "・文字数を指定する: <br> 「600文字以内で作成してください。」<br><br>" +
            "・打ち合わせ予約リンクを挿入する:<br> 「本文の後半に以下の項目を必ず記載してください。<br>" +
            "「ご希望の方は、以下のリンクからご予約いただければと思います。<br>" +
            "◆ 打ち合わせ予約リンク https://～～～ ※1分程度でご予約が完了します」」<br>",

        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "は必須項目です。入力してください。",

        return: "戻る",
        next: "次へ",
        update: "更新",

        import: "ファイル・URLで入力",
        delete_title: "削除",
        delete_confirm: "添付ファイルを削除しますか？",
        OK: "削除する",
        cancel: "キャンセル"
    },

    SalesListsImportView: {
        h3: "CSVインポート",
        csv_drag: "CSVファイルをドラック&ドロップ、または",
        input_directly: "または CSVを使用せず直接入力する",

        table_name: "マッピング",

        field_name: "取り込み項目",
        csv_field: "CSVカラム",
        sample_value: "サンプル値",

        company_name: "会社名",
        company_url: "URL",
        company_detail: "会社概要",
        email: "メールアドレス",
        tel: "電話",
        contact_url: "連絡先URL",
        mail_text: "コンテンツの送信",

        upload_file: "インポート",
    },
    sales_templates: {
        h4: "メール文面テンプレート一覧",
        search_keyword: "キーワード：",
        list_count: "リスト数：",
        filter: "絞り込み",
        handle_create: "新規作成",
        list_title: "テンプレート名",
        author: "作成日時",
        edit: "編集",
        delete: "削除",

        delete_confirm: "選択したテンプレートを削除することを確認します?",
        OK: "もちろん",
        cancel: "キャンセル"
    },

    sales_templates_new: {
        h3: "テンプレート新規作成",

        template_name: "テンプレート名",
        template_text: "サンプルメール文面",

        new: "作成",
        cancel: "キャンセル",

        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "は必須項目です。入力してください。",
    },

    sales_templates_edit: {
        h3: "テンプレートの編集",

        template_name: "テンプレート名",
        template_text: "サンプルメール文面",

        update: "更新する",
        cancel: "キャンセル",

        check_modal_title: "警告",
        check_modal_close: "閉じる",
        check_modal_msg: "は必須項目です。入力してください。",
    },

    SalesUsageDetailsView: {
        usage_detail: "ご利用状況",
        item: "項目",
        total_number: "合計件数",
        number_of_success: "成功数",
        number_of_failures: "失敗数",
        number_of_articles_generated: "文章生成数：",
        number_of_emails_sent: "メール送信数：",
        amount_detail: "ご利用金額",
        total_amount: "合計金額：",
        detail: "内訳：",
        quantity: "数量",
        unit_price: "単価",
        amount: "金額",
        base_amount: "基本利用料",
        base_amount1: "基本利用料(",
        base_amount2: "件まで含む)",
        append_amount: "追加生成分",
        back_button: "戻る"
    },

    OptionsErrorView: {
        h1: "アクセス権限がありません",
        error_message: "For Salesへのアクセス権限がありません。",
        back_button: "戻る"
    }

}
export default ja;